export function EmptySymbol() {
    return null;
}
